import React from "react"
import PropTypes from "prop-types"

class Tag extends React.Component {
    constructor(props) {
      super(props)
    }

    styledTag() {
      if(this.props.selected){
        return {
            border: `2px solid ${this.props.tag.color}`,
            borderRadius: 20,
            padding: 8,
            paddingRight: 20,
            paddingLeft: 20,
            margin: 5,
            backgroundColor: this.props.tag.color,
            cursor: 'pointer',
          }
      } else {
        return {
          border: '2px solid',
          borderColor: this.props.tag.color,
          borderRadius: 20,
          padding: 8,
          paddingRight: 20,
          paddingLeft: 20,
          margin: 5,
          cursor: 'pointer',
        }
      }
    }

    render() {
      if(this.props.onClick === undefined) {
        return(
          <div style={{border: `2px solid ${this.props.tag.color}`, borderRadius: 20,padding: 8, paddingRight: 20, paddingLeft: 20, margin: 5, backgroundColor: this.props.tag.color}}>
            <h4 style={{color: 'white', fontSize: 16}}>{this.props.tag.name}</h4>
          </div>
        )
      }
      return(
        <div style={this.styledTag()} onClick={() => this.props.onClick(this.props.tag.id)}>
          <h4 style={{color: (this.props.selected ? 'white' : this.props.tag.color), fontSize: 16}}>{this.props.tag.name}</h4>
        </div>
      )
    }
}

export default Tag;
